import Swiper, { Navigation, Grid } from 'swiper';
import "swiper/scss";
import "swiper/scss/grid";
import "swiper/scss/navigation";

const testimonialSlider = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const swiper = new Swiper('[data-testimonial-swiper]', {
            modules: [Navigation, Grid],
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: "[data-testimonial-slider-next]",
                prevEl: "[data-testimonial-slider-prev]",
            },
            breakpoints: {
                1280: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    grid: {
                        rows: 2,
                        fill: 'row',
                    },
                },
                768: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    grid: {
                        rows: 2,
                        fill: 'row',
                    },
                }
            }
        });
    });
}

export { testimonialSlider }